module.exports = __webpack_public_path__ + "static/media/Probopass_gaussian2.c7b801d8.png";